// src/services/transactionApi.js
import axios from 'axios';

// Define the base URL for the API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Create an axios instance
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    // Don't include credentials by default since the server doesn't support it
    withCredentials: false,
});

// Add response interceptor for error handling
apiClient.interceptors.response.use(
    response => response,
    error => {
        // Check if error is due to authentication issues
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            console.error('Authentication error in API call:', error.response.status);
            // You could trigger a logout or redirect to auth page here
        }

        // For CORS errors, log a more helpful message
        if (error.message && error.message.includes('Network Error')) {
            console.error('Potential CORS issue with the API call');
        }

        return Promise.reject(error);
    }
);

// Transaction monitoring API service
const TransactionApiService = {
    // Get pending transactions that need acknowledgment
    getPendingTransactions: () => {
        return apiClient.get('/api/transactions/pending')
            .catch(error => {
                // Specific error handling for this endpoint
                console.warn('Error fetching pending transactions, this might be expected if the server does not have this feature');
                // Return an empty list to avoid app crashes
                return { data: { transactions: [] } };
            });
    },

    // Acknowledge a transaction with pain slider
    acknowledgeTransaction: (transactionId, painLevel, budgetCategory) => {
        return apiClient.post('/api/transactions/acknowledge', {
            transaction_id: transactionId,
            pain_level: painLevel,
            budget_category: budgetCategory
        });
    },

    // Get budget categories
    getBudgets: () => {
        return apiClient.get('/api/transactions/budgets')
            .catch(error => {
                // Specific error handling for this endpoint
                console.warn('Error fetching budgets, this might be expected if the server does not have this feature');
                // Return an empty list to avoid app crashes
                return { data: { budgets: [] } };
            });
    },

    // Force refresh of transactions
    forceRefresh: () => {
        return apiClient.post('/api/transactions/force-refresh');
    },

    // Check if there are pending transactions
    getTransactionStatus: () => {
        return apiClient.get('/api/status/transactions')
            .catch(error => {
                // Specific error handling for this endpoint
                console.warn('Error checking transaction status, this might be expected if the server does not have this feature');
                // Return a default status to avoid app crashes
                return { data: { has_pending_transactions: false, pending_count: 0 } };
            });
    }
};

export default TransactionApiService;